<template>
    <div>
        <div class="home-btn d-none d-sm-block">
            <a href=""><i class=""></i></a>
        </div>

        <div class="account-pages my-5 pt-5">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-8 col-sm-12">
                        <div class="text-center"><img src="../assets/logo.png" width="200" height="70"></div>


                        <div v-if="!passReady">
                            <div class="alert alert-info mt-5 text-center py-1" >
                                <span>This link is no longer valid</span>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 text-center">
                                    <p class="text-muted">Click here to
                                        <a href="/#/reset_password" class="text-dark ml-1">reset password</a>
                                    </p>
                                </div>
                            </div>
                        </div>


                        <div v-show="passReady">
                            <h6 class="text-right mt-3">Change Password</h6>

                            <hr>
                            <form  action="#" @submit.prevent class="mt-3">
                                <div class="col-md-6 col-sm-12 form-group mb-3">
                                    <label for="password"><span>*</span>New Password</label>
                                    <input class="form-control txt" type="password" v-model="$v.formInfo.password.$model"  :class="{'is-invalid':$v.formInfo.password.$error, 'is-valid':!$v.formInfo.password.$invalid}" >
                                </div>
                                <div class="col-md-6 col-sm-12 form-group mb-3">
                                    <label for="confirmPassword"><span>*</span> Confirm Password</label>
                                    <input class="form-control txt" type="password" v-model="$v.formInfo.confirmPassword.$model"  :class="{'is-invalid':$v.formInfo.confirmPassword.$error, 'is-valid':!$v.formInfo.confirmPassword.$invalid}" >
                                </div>
                                <div class="form-group mb-3 text-center">
                                    <button class="btn btn-primary btn-sm" :disabled="$v.formInfo.$invalid" type="submit" @click.prevent="passwordReset()" v-if="!processing">Change Password </button>
                                    <button class="btn btn-primary btn-sm" disabled type="submit" v-if="processing">Change Password </button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </div>
    <!-- end container -->
</template>

<script>
import { required, sameAs, minLength} from 'vuelidate/lib/validators'

export default {
    name: 'PasswordReset',
    data() {
        return {
            formInfo: {
                password: null,
                confirmPassword: null,

            },
            notPassed: true,
            passReady: false,
            processing: false
        };
    },
    mounted(){
        const baseUr = `${this.$urlAuth}/password/verify`;
        let id = this.$route.params.id;
        this.$http.post(baseUr, {passwordToken: id})
        .then((result) => {
            // console.log(result)
            if(result.data.data.code == "S200"){
                this.passReady = true;
                this.notPassed = false;
                this.$router.path('/login')
            }else if(result.data.data.code == "E300"){
                this.notPassed = false;
            }
        }).catch(err => console.log(err))
    },

    validations: {
        formInfo: {
            password: {
                required,
                minLength: minLength(8),
                strongPassword(password) {
                    return (
                        /[a-z]/.test(password) && // checks for a-z
                        /[A-Z]/.test(password) && // checks for A-Z
                        /[0-9]/.test(password) && // checks for 0-9
                        /\W|_/.test(password) // checks for special char
                    );
                }
            },
            confirmPassword:{
                    required, minLength: minLength(8),
                    sameAsPassword: sameAs('password')
            }
        }
    },

    methods:{
        passwordReset(){
            this.processing = true
            this.$toastr.removeByType("error"); // remove all error type message
            // Only send after validations
            this.$v.formInfo.$touch();
            let id = this.$route.params.id;
            if (this.$v.formInfo.$invalid || this.$v.formInfo.$error) {
                // Do nothing
            } else {
                // submit logic
                const baseU = `${this.$urlAuth}/password/reset`;

                this.$http.post(baseU, {
                    password: this.formInfo.password,
                    confirmPassword: this.formInfo.confirmPassword,
                    passwordToken: id
                })
                .then((result) => {
                    console.log(result)
                    if(result.data.data.code == "S200"){
                        this.$router.push({path: "/login"})
                    }else if(result.data.data.code == "E304"){
                        this.passReady = false;
                        this.$toastr.e(result.data.data.message[0], 'Error message'); // remove all error type message
                    }
                    this.processing = false
                }).catch(err => console.log(err))
            }
        }
    }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
    .is-valid{
        border-color:green;
    }
    .is-invalid{
        border-color:red,
    }
    span{
        color:red
    }
    div, button, input{
    font-family: Poppins;
    font-size: 14px ;
    font-weight: 500;
    color: #6C757D;
    overflow: visible;
    }
    .txt {
    font-size: 13px !important;
    }
    .account-pages {
    background-color: #fff;
    }
    button {
    color: white;
    transition-duration: 0.4s;
    }
    button:hover {
    background-color: #1c6aa5 !important;
    font-size: 13px;
    }
</style>